<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title>아이디(휴대전화번호)</v-list-item-title>
      <v-text-field
        solo
        ref="refCell"
        type="text"
        label="아이디(휴대전화번호)"
        :height="formHeight"
        :rules="[cellRules.required, cellRules.counter, cellRules.check]"
        v-model="userData.cell"
      >
        <template v-slot:append>
          <v-btn x-small depressed rounded @click="$emit('sendCode')">
            인증번호 전송</v-btn
          >
        </template>
      </v-text-field>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
const rulesService = require("@/utils/rules.js");
export default {
  props: {
    userData: {
      type: [Object],
    },
  },
  data() {
    return {
      formHeight: 52,
      cellRules: rulesService.cellRules(),
    };
  },
  mounted() {
    setTimeout(() => {
      this.$refs.refCell.focus();
    }, 300);
  },
};
</script>
<style lang="">
</style>